export const baseUrl = import.meta.env.DEV
  ? 'http://localhost:3021'
  : `${window.location.protocol}//${window.location.hostname}`

export const baseUrlImages = import.meta.env.DEV
  ? import.meta.env.VITE_BASE_URL_IMAGES || 'https://test.redbox.systems'
  : baseUrl

export const apiUrlV2 = baseUrl + '/gqlv2'
